import { render, staticRenderFns } from "./PricingDetails.vue?vue&type=template&id=51af3bdd&scoped=true"
import script from "./PricingDetails.vue?vue&type=script&lang=js"
export * from "./PricingDetails.vue?vue&type=script&lang=js"
import style0 from "./PricingDetails.less?vue&type=style&index=0&id=51af3bdd&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51af3bdd",
  null
  
)

export default component.exports